export default {
  message: 'hello i18n !!',
  welcome: 'Welcome',
  totalAssetValue: 'Total asset value', //  총 보유 자산
  welcome_sir: '',
  errorServer: 'Internet connection is unstable. Please try again later.',
  requiredMessage: 'This field is required.',
  close: 'Close',
  back: 'Back',
  cancel: 'Cancel',
  register: 'register',

  login: {
    id: 'Account name(e-mail)',
    password: 'Password',
    autoLogin: 'Keep me logged in',
    signup: 'Sign up',
    forgot: 'Forgot your password?',
    login: 'Login',
    errors: 'Invalid login or password.',
    requiredMessage: 'This field is required.',
    emailMessage: 'Invalid ID(Email).',
  },
  signup: {
    id: 'ID(required)',
    idPlaceholder: 'Please enter your Email Address.',
    password: 'Password(required)',
    passwordPlaceholder: 'Please enter a password.',
    confirmPassword: 'Confirm Password(required)',
    refferalCode: 'Refferal code',
    refferalCodePlaceholder: 'Please enter the refferal code.',
    back: 'Back',
    signup: 'Sign up',
    requiredMessage: 'This field is required.',
    emailMessage: 'Invalid ID(Email).',
    passwordMessage: 'Passwords do not match.',
    regexMessage:
      'Passwords must be at least 8 characters with one uppercase letter, one number, and one special character.',
    duplicateMessage: 'Email has already been taken.',
    recommendMessage: 'Invalid referral code.',
    withdrawMessage: '탈퇴한 계정은 한달 이후 재가입 가능합니다 .',
  },
  password: {
    title: 'Request Password Reset',
    email: 'Email address',
    emailPlaceholder: 'Please enter your Email Address.',
    request: 'Request',
    invalidMessage: 'Invalid ID(Email).',
    tokenMessage: 'Invalid token.',
    desc1:
      'An email has been sent with a verification code to reset your password.',
    desc2:
      'Please check your email to proceed with the password reset process. The verification code will be valid for only 5minutes.',
    password: 'Password',
    passwordPlaceholder: 'Please enter your password.',
    confirmPassword: 'Confirm Password',
    verificationCode: 'Verification Code',
    verificationCodePlaceholder: 'Please enter the verification code.',
    submit: 'Submit',
    successMessage: 'Your password is successfully changed.',
  },
  update: {
    title: 'Update Coming Soon',
    desc: 'function will be updated.',
  },
  home: {
    myWalletAddress: 'My wallet address',
    copyClipboard: 'Copy to clipboard',
    copySuccess: 'My wallet address has been copied to the clipboard.',
    copyFail: 'Copy failed.',
    popup: {
      title: '{num} Winning Numbers for Paycam Lotto',
      noPopup: `Don't show this for a week`,
      detail: 'View more',
    },
  },
  nft: {
    purchasePrice: 'purchase price', // 구매가
    quantity: 'quantity', // 구매 수량
    qty: 'Qty', // 단위(개)
    registration: 'registration', // '등록하기'
    regConfirm: 'Would you like to register?', // 등록하시겠습니까? ,

    regCardMsg: 'Please register your card serial number.',
    serialNumber: 'serial number',
  },
  send: {
    smsgPlaceholder: 'memo',
    smsgLabel: 'memo',
    coinLabel: 'Select Coin',
    coinPlaceholder: 'Select Coin that you want to withdraw.',
    availableAmount: 'Available amount for withdrawal',
    pliDesc:
      'The PLI paid through the event can only be withdrawn after switching to PLP through the swap request.',
    amountLabel: 'Amount',
    amountPlaceholder: 'Please enter the amount for withdrawal.',
    addressLabel: 'Wallet Address',
    addressPlaceholder: 'Please enter the Withdraw Address.',
    feeLabel: 'Transaction Fee',
    slow: 'slow',
    average: 'Average',
    fast: 'Fast',
    about: 'About',
    feeCaution: 'Low fee(gas price) can cause the failure of transaction.',
    expactFee: 'Estimated Fee',
    send: 'Request withdrawal',
    refreshModal: {
      message: 'Failed receiving fee(gas) data.',
      home: 'Go to Home',
      reload: 'Re-receive fee(gas) data',
    },
    confirmModal: {
      amount: 'Amount',
      address: 'Withdraw Address',
      message: 'Do you want to withdraw?',
      cancel: 'Cancel',
      send: 'Submit',
    },
    successModal: {
      title: 'Withdrawal request submitted',
      desc: 'Total Amount',
      confirm: 'Withdrawal request Result',
    },
    authModal: {
      title: 'Authentication',
      message: 'Verification code has been sent (Number only).',
      code: 'Verification Code(Number Only)',
      checkMsg: 'Please check your Verification Code',
      // confirm: 'Withdrawal request Result' ,
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    amountRulesRequired: 'Please enter the Amount.',
    amountRulesConfirmed: 'Please check the Amount.',
    addressRulesRequired: 'Please enter the Withdraw Address.',
    addressRulesConfirmed: 'Invalid Withdraw Address.',
    smsgRules20length: 'You can enter up to 10 characters.',
    coinRulesRequired: 'Please select Coin.',
    feeMessage: 'Insufficient fee for withdrawal.',
    insufficientMessage: 'Please check the Amount.',
    failMessage: 'You\'ve failed to withdraw the fund.',
    sendBtn: 'Send',
    targetNotFound: 'Target not found.',
    phoneNumber: 'Phone Number',
    walletAddress: 'Wallet Address',
  },
  gnb_winResult: 'My result History',
  gnb_saveNumber: 'Saved numbers',
  gnb_preRound: 'Previous results',
  gnb_winCriteria: 'Winning Criteria',
  lotto: {
    imgBanner: '@/assets/img/event-card.png',
    todayNumber: 'Today’s free lotto numbers',
    getLottoNumber: 'Get free lotto ticket',
    withPaypal: 'Pay with PayPal',
    purchase: 'Purchase',

    confirmModal: {
      // 로또 신청 팝업
      txt_check: 'I agree to the free payment of the Cambodia Lotto.', //캄보디아 로또 무료 지급에 동의합니다
      imgBanner: '@/assets/img/event-poster.png',
      amount: 'Choosing a number',
      getFree: 'Get free lotto ticket',
    },
    confirmModalResult: {
      // 신청 결과 팝업
      confirm: 'Confirm', // 확인하기
      close: 'Close', // 닫기
      ok1: 'Free Cambodian lotto has been paid.',
      ok2: 'Please check the paid lottery or on the [Winning Results] page.', //무료 캄보디아 로또가 지급되었습니다. 지급된 로또는 [당첨결과] 페이지에서 확인하세요
      err: 'You have already applied for the event today.', // 오늘은 이미 이벤트에 응모하셨습니다
      failMessage: 'Purchase failed. Please try again later.',
      timeoutMessage: 'Lotto tickets are not on sale at this time.',
      endMessage: 'The free Lotto event has ended.',
    },
    selectNumModal: {
      txt_choseNumber: 'Please select {num} numbers.', // ex 6개의 번호를 선택하세요
      reset: 'Reset', //초기화
      auto: 'Auto',
      submit: 'Submit', // 선택완료
      modify: 'Modify',
      errorMessage: 'You can’t select more numbers exceeding 6 numbers.',
      countMessage: 'You have to choose 6 numbers.',
    },
    gameNum: '{num} paycam lotto',
    congratulation: 'Congratulations!',
    prize: '{num} prize',
    win: 'Win',
    lose: 'Lose',
    noResult: 'To be drawn',
    noOrder: 'No purchase history',
    matchBonus: 'plus the Bonus Number',
    match: 'Match {num} out of 6 numbers',
    prizeUnit: 'won',
    prizeNum: '{num}',
    lottoOrderDesc: 'Able to buy unlimitedly',
    lottoOrderBtn: 'Click here to buy lotto',
    orderModal: {
      message: 'One lottery ticket costs {price}PLP or {price}PLI.',
      manual: 'manual selection',
      auto: 'automatic selection',
      unlimit: 'buy unlimitedly',
      manualDesc: 'You can select your lotto number personally.',
      autoDesc: 'You can purchase the auto-selected lotto number.',
      next: 'next',
    },
    attendBtn: 'Attendance check',
    attendMessage1: 'Complete',
    attendMessage2: `You can check it at 'Daily attendance check' button on [CONFIG] Tab.`,
  },
  myNum: {
    //lotto/mynumber
    modify: 'Modify',
    noMyNum: 'There are no saved numbers.',
    deleteModal: {
      message: 'Delete saved numbers?',
      cancel: 'Cancel',
      submit: 'Delete',
      confirmMessage: 'Saved numbers are deleted.',
      failMessage: 'Failed deleting saved numbers.',
    },
    confirmMessage: 'Numbers are successfully registered.',
    failMessage: 'Failed registering numbers..',
  },
  order: {
    //lotto/order
    autoSelection: 'Automatic Selection',
    autoInput1: 'Buy ',
    autoInput2: ' tickets',
    inputPlaceholder: 'Enter Num',
    exceedMessage: '* The number of purchases has been exceeded.',
    manualSelection: 'Manual Selection',
    savedNum: 'Saved Num',
    purchaseLotto: 'Purchase Lotto', // 로또 구매
    reset: 'Reset', // 초기화
    submit: 'Submit', //등록
    modify: 'Modify', // 수정
    purchase: 'Purchase', //무료로 로또 받기
    modalTitle: 'How to buy',
    buyTo: 'Buy to {name}',
    holding: 'Holding ',
    quantity: 'Purchase quantity',
    ticket: ' tickets',
    price: 'Price',
    fee: 'Fee',
    total: 'Total',
    remaining: 'Remaining balance',
    next: 'next',
    toBeOpen: 'It will be supported later.',
    paypalDesc: '* PayPal payment function will be supported later.',
    feeModal: {
      title: 'Information of Fee',
      text1: 'Apply ‘Fast’ speed based on ETH gas staion.',
      text2:
        'Due to the low fee policy, there is a possibility of transaction failure,',
      text3: 'which Fame Wallet is not responsible for.',
    },
    myNumModal: {
      title: 'Saved Numbers',
      message: 'There are no saved numbers.',
      submit: 'Submit',
    },
    paypalModal: {
      confirm: 'Would you like to proceed with the lotto purchase?', // 로또 구매를 진행하시겠습니까?
      total: 'Total', //총 수량
      cancel: 'Cancel', // 취소
      submit: 'Submit', // 구매하기
    },
    chooseMessage: 'Please select the numbers for purchase.',
    freeMessage: 'Only 1 free Lotto ticket is available.',
    successTitle: 'Lotto purchase completed',
    successText1: 'You can check the purchased lottery number',
    successText2: 'on the [Winning Completed] page.',
    successBtn: 'Go To Lotto Page',
  },
  pay: {
    //pay
    pay: 'Pay', // 결제
    updateSoon: 'Update Coming Soon', // 업데이트 예정
    txt_update: '“Pay” function will be updated.', // pay 기능은 업데이트 예정입니다.
    scan_do_it: 'barcode on&nbsp<a href="/#/buy">kiosk scan</a>&nbsp do it.', // '키오스크에 바코드를 스캔 하세요.'
  },
  cards: {
    OwnerInformation: 'Owner information',
    LastName: 'Last Name',
    FirstName: 'First Name',
    eMail: 'E Mail',
    Mobile: 'Mobile',
    BirthDay: 'Birth day',
    Gender: 'Gender',
    NationalityCode: 'Nationality Code',
    IDNumber: 'ID Number',

    CardInformation: 'Card information',
    CardNumber: 'Card Number',
    Balance: 'Balance',
    Amount: 'Amount',
    Charged: 'Charged',
    RecommendInformation: 'Recommend information',
    ReferCode: 'Refer Code',
  },
  eventGame: {
    congratulations: 'Congratulations!',
    clickAchieved: '{tier} clicks achieved!',
    requestReward: 'Would you like to request a reward?',
    request: 'Request',
    walletConnect: 'Connect Wallet',
    selectWallet: 'Select the wallet you want to connect.',
    manualAddress: 'Manual Wallet Address (Optional)',
    manualAddressPlaceholder: 'Enter address starting with 0x',
    useManualAddress: 'Use Manual Wallet Address',
    currentAddress: 'Currently connected address: {address}',
    cancel: 'Cancel',
    remaining: 'Remaining {remaining} / {threshold} clicks',
    totalReward: 'Total Reward',
    usedOut: 'Used (Withdrawn)',
    availableConvert: 'Available to Convert',
    loadingReward: 'Loading reward points...',
    tooltipReward: 'Used (Withdrawn): {out} / Available to Convert: {late}',
    wallet: 'Wallet',
    walletConnectLogin: 'Connect Wallet & Login',
    connectWallet: 'Connect Wallet',
    playGame: 'Play Game',
    signature: 'Signature',
    rewardRequest: 'Request Reward ({tier} achieved)',
    rewardWaiting: 'Reward request is pending. Please complete the reward request.',
    signFirst: 'Please sign with the Play Game (Sign) button first.',
  },
  config: {
    TradeHistory: 'Trade History',

    Notice: 'Notice',
    refferalCode: 'Refferal code', // 'refferal code'
    copyMessage: 'Referral URL is successfully copied.',
    shareMessage: '[web3pays]Get 125PLI by registering now!', //이 메세지는 추후 변경 예정
    shareSuccess: 'Sharing is completed.',
    shareFail: 'Failed sharing.',
    lockUp: 'Lock-up',
    noLockUp: 'No coins are being locked up.',
    swapCoin: 'Swap coins',
    attendanceCheck: 'Daily attendance check',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    pliHistory: 'PLI History',
    performance: 'My Performance',
    transHistory: 'Transaction History',

    store: 'Store', // 매장
    storeNone: 'No Store.',
    recommender: 'Recommender', // 추천인
    recommenderNone: 'No Recommender', // 추천인

    ReferralList: 'Referral list', // 추천인목록
    PaymentHistory: 'Payment history', // 결제이력
    PaymentHistoryNone: 'No Payment history.',
    staking: 'Staking',
    copyReferralLink: 'Copy Referral Link',
    referralLinkCopied: 'Referral link copied successfully.',
    copyFailed: 'Failed to copy.',

    logOut: 'Log Out',
    language: 'Language',
    submit: 'Submit',
    withdrawMessage1_1: 'If you want to delete your account, click ',
    here: 'here.',
    withdrawMessage1_2: '',
    withdrawMessage2: 'If you delete your account,',
    withdrawMessage3:
      'all PLI will be destroyed along with account information.',
    withdrawMessage4:
      'Accounts that have been deleted can be re-registered after one month.',
    withdrawMessage5: 'Are you sure to leave?',
    withdraw: 'Delete Account',
    withdrawComplete: 'Account withdrawal completed.',
    logoutMessage: 'Are you sure to log out now?',
  },
  Notice: {
    tiker: 'Notice',
    title: 'Notice',
    lists: 'Lists',
    listsNone: 'No registered contents.',
    more: 'More',
  },
  attend: {
    attendanceCheck: 'Daily attendance check',
  },
  history: {
    // config/history/eth
    more: 'More',
    callContract: 'Call Contract', //  컨트랙트 호출
    noHistory: 'There is no history.', // There is no history
    detail: 'Transaction details',
    close: 'Close',
  },
  recommend: {
    //config/recommend
    myPerformance: 'My Performance ', // 나의 실적
    genPromote1: '1st generation promote',
    genPromote2: '2nd generation promote',
    paid: 'Paid',
    join: 'Join', // 가입
    noReferrals: 'No referrals have been signed up.', // No referrals have been signed up
    people: '',
    phone: 'Phone',
  },
  point: {
    //config/point
    join: 'Sign up Bonus', // 회원가입
    genPromote1: 'generation promote',
    genPromote2: 'generation promote',
    attend: 'Daily attendance check',
    pli_out: 'Request PLI swap',
    pli_fee: 'PLI swap fee',
    pli_lotto_order: 'Purchase lottery',
    pli_exchange_in: 'PLI paid by swap',
    supporters_add: 'Paycam supporter bonus',
    supporters_del: 'Paycam supporter retieved',
    lottoGive: 'Winnings paid',
    unpaid: '(Unpaid)',
    paid: '(Paid)',
    more: 'More',
    deposit: 'Deposit',
    withdrawal: 'WithDrawal',
    exchangeApplication: '환전 신청',
    exchangeAmount: '환전 수량',
    amountPlaceholder: '최소 10,000 PLI',
    amountMax: 'Max',
    availablePli: '환전 가능 PLI',
    fee: '수수료',
    totalAmount: '총 환전액',
    includeFee: '(수수료포함)',
    close: '닫기',
    successExchange: '환전신청 완료',
    detailResult: '환전신청 결과보기',
    confirmMessage: '환전하시겠습니까?',
    cancel: '취소',
    submitExchange: '환전 신청하기',
    amountError: '10,000 이상 환전 가능합니다.',
    amountNull: '환전 수량을 입력하세요.',
    insufficientError: '환전 가능 수량을 확인해주세요.',
    xuserError: '환전 신청이 불가능합니다.',
  },
  swap: {
    //config/swap
    selectCoin: 'Select Coin', // Select Coin
    amount: 'Amount to be Swapped', // Amount to be Swapped
    reset: 'Reset',
    requestSwap: 'Request Swap',
    swapSuccess: 'Swap request completed successfully.',
    errCoin: 'Choose a wallet to swap.', // Choose a wallet to swap
    errAmount: 'Enter the quantity to be swapped.', // Enter the quantity to be swapped
    messageModal: {
      amountFail: 'Insufficient fund.',
      fail: 'Coin transfer failed.',
      close: 'Close',
    },
    successModal: {
      title: 'Swap request completed',
      desc: 'Amount for swap',
      confirm: 'Swap request details',
    },
  },
  staking: {
    period: 'Period',
    days30: '30 Days',
    days60: '60 Days',
    days90: '90 Days',
    quantity: 'Quantity',
    quantityPlaceholder: 'Enter quantity.',
    expectedValue: 'Expected Value',
    description: 'The current staking program is operated by AILabs.\nPlease proceed only if you agree.\n\nUMUC Coin Deposit Policy\n30 Days: 8%\n60 Days: 9%\n90 Days: 10%\n\nThis is additional payment in the form of an airdrop.',
    stakingBtn: 'Staking',
    stakingStatus: 'Currently staked.',
    tradeHistory: 'Trade History',
    enterQuantity: 'Please enter the quantity of tokens to stake.',
    minQuantity: 'The quantity of staking tokens must be at least {min}.',
    checkAvailable: 'Please check the available quantity of tokens for staking.',
    success: 'Staking was successful.',
    checkQuantity: 'Please check the available UMUC quantity for staking.',
    failed: 'Staking failed.',
  },
  sms: {
    phone: '휴대전화',
    phonePlaceholder: '전화번호를 입력하세요.',
    codePlaceholder: '인증번호를 입력하세요.',
    codeBtn: '인증번호 받기',
    m01: '유효하지 않은 전화번호입니다.',
    m02: '인증번호를 발송했습니다.',
    m03: '인증번호는 10분간 유효합니다.',
    m04: "If you're not receiving the message for a while, please check your spam or rejected message folder.",
    m05: '유효한 인증코드가 있습니다.',
    m06: '이미 가입된 휴대전화 번호입니다.',
    m07: '당일 인증요청을 초과하였습니다.',
    m08: '익일 인증 가능합니다.',
    m09: '메일정보가 없습니다.',
    m10: '인증번호 전송에 실패하였습니다. 다시 시도해주세요.',
    m11: '인증이 필요합니다.',
    m12: '휴대전화 인증이 확인되었습니다.',
    m13: '일치하는 정보가 없습니다.',
    m14: '인증번호가 일치하지 않습니다.',
    m15: '인증번호를 발송할 수 없습니다.',
    m16: '인증번호를 발송할 수 없습니다.',
  },
  verify: {
    title: 'Enter Verification Code',
    desc1: 'The verification code has been sent to',
    desc2: 'the phone number you entered.',
    desc3: 'Please enter the verification code.',
    codePlaceholder: 'Please enter the received verification code',
    recommendPlaceholder: 'Recommend Code (Optional)',
    serviceTerms: 'Terms of Service',
    financeTerms: 'Electronic Financial Transaction Terms',
    loginBtn: 'Login',
    confirmBtn: 'Confirm',
    requiredCode: 'Please enter the verification code.',
    requiredService: 'Please check the terms of service.',
    requiredFinance: 'Please check the electronic financial transaction terms.',
    invalidToken: 'Invalid verification code.',
    tokenTimeout: 'Verification code has expired.',
  },
  common: {
    phoneEmailLabel: 'Phone & Email',
    walletAddressLabel: 'Wallet Address',
    verificationCodeLabel: 'Verification Code',
    recommenderLabel: 'Recommender',
    sendVerificationBtn: 'Send Verification Code',
    confirmBtn: 'Confirm',
    verificationMismatchAlert: 'The verification request phone number does not match',
    verificationConfirmAlert: 'Please check the verification code.',
    verificationSuccessAlert: 'Verification completed.',
    phoneNumberCheckAlert: 'Please check your phone number',
    paymentAmountAlert: 'Please enter the payment amount',
    paymentInfoAlert: 'Please recheck the payment information',
    paymentAvailableAlert: 'Please check the available payment amount',
    retryLaterAlert: 'Please try again later',
    placeholderWon: 'KRW',
    placeholderQty: 'pcs',
  },
  card: {
    tradeType: {
      100: 'Charge',
      110: 'Cash Withdrawal',
      120: 'Deposit',
      121: 'Transfer',
      150: 'Priority Approval',
      151: 'Payment',
      200: 'Settlement',
      300: 'Balance Inquiry',
      500: 'Fee',
    },
  },
  txHistory: {
    contractCall: 'Contract Call',
  },
  staff: {
    staffLabel: 'Staff',
    adminLabel: 'Admin',
  },
}
